import { useEffect } from "react";

const TextScroll = () => {
  useEffect(() => {
    const first = document.querySelector("#first");
    const second = document.querySelector("#second");
    const third = document.querySelector("#third");
    const fourth = document.querySelector("#fourth");
    const animate = (element, position) => {
      element.style.transform = `translateX(${position}px)`;
    };
    let lastKnownScrollPosition;
    let startScrollPosition;
    document.addEventListener("scroll", function () {
      lastKnownScrollPosition = window.scrollY;
      startScrollPosition = window.scrollY;
      window.requestAnimationFrame(function () {
        if (window.scrollY > 100) {
          animate(first, lastKnownScrollPosition * 1);
        } else if (window.scrollY < 150) {
          animate(first, startScrollPosition * 1);
        }
        if (window.scrollY > 250) {
          animate(second, lastKnownScrollPosition * -1);
        } else if (window.scrollY < 200) {
          animate(second, startScrollPosition * 0);
        }
        if (window.scrollY > 350) {
          animate(third, lastKnownScrollPosition * 1);
        } else if (window.scrollY < 300) {
          animate(third, startScrollPosition * 0);
        }
        if (window.scrollY > 450) {
          animate(fourth, lastKnownScrollPosition * -1);
        } else {
          animate(fourth, startScrollPosition * 0);
        }
      });
    });
  }, []);

  return (
    <div className="bg-light-pink pt-11">
      <div className="overflow-hidden">
        <div
          className="overflow-hidden md:w-[230vw] md:h-[70vh] xl:w-[200vw] xl:h-auto"
          id="container"
        >
          <h1
            className="transition-transform duration-200 ease-linear font-normal text-left md:text-8xl md:leading-tight xl:text-[160px] xl:leading-tight"
            id="first"
          >
            <span className="font-jomolhari">APPLICATION</span>
          </h1>
          <h2
            className="transition-transform duration-500 ease-linear font-normal text-left md:text-8xl md:leading-tight xl:text-[160px] xl:leading-[150px] px-48"
            id="second"
          >
            <span className="font-jomolhari">TO TRANSFER</span>
          </h2>
          <h2
            className="transition-transform duration-800 ease-linear font-normal text-left md:text-8xl md:leading-tight xl:text-[160px] xl:leading-tight"
            id="third"
          >
            <span className="font-jomolhari">DATA USING</span>
          </h2>
          <h2
            className="text-apple transition-transform duration-[1.1s] ease-linear font-normal text-left md:text-8xl md:leading-tight xl:text-[160px] xl:leading-[150px] ml-24"
            id="fourth"
          >
            <span className="font-jomolhari">NFC TECHNOLOGY</span>
          </h2>
        </div>
      </div>
    </div>
  );
};

export default TextScroll;
